/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function PaintBrushBroad(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M216,24H72A40.04552,40.04552,0,0,0,32,64v72a24.0275,24.0275,0,0,0,24,24h46.77588l-6.69531,46.86816A7.97979,7.97979,0,0,0,96,208a32,32,0,0,0,64,0,7.97979,7.97979,0,0,0-.08057-1.13184L153.22412,160H200a24.0275,24.0275,0,0,0,24-24V32A8.00008,8.00008,0,0,0,216,24ZM72,40H176V80a8,8,0,0,0,16,0V40h16v64H48V64A24.0275,24.0275,0,0,1,72,40Z" />
    </Svg>
  );
}

export default PaintBrushBroad;
